import * as React from "react";
import clsx from "classnames";

type TextInputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  label: string;
  labelClassName?: string;
  error?: string;
  "data-testid"?: string;
};

// eslint-disable-next-line react/display-name
export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ label, labelClassName, "data-testid": dataTestId, error, ...inputProps }, ref) => {
    const className = clsx(
      "block",
      "w-full",
      "border",
      "rounded-md",
      "border-solid",
      "border-neutral-300",
      !error && "hover:border-platform-600",
      "hover:outline-hidden",
      "focus:border",
      !error && "focus:border-platform-600",
      "focus:outline-hidden",
      "placeholder-neutral-400",
      "placeholder-text-sm",
      "py-2",
      "px-3",
      error && "border-red-700",
      "bg-white"
    );

    return (
      <label className={clsx("mb-6", "relative!", "w-full", error && "text-red-700")}>
        <span className={clsx("block", "mb-1", labelClassName)}>{label}</span>
        <input ref={ref} {...inputProps} className={className} data-testid={dataTestId ?? "text-input"} type="text" />
        {Boolean(error) && (
          <span
            data-testid={`${dataTestId ?? "text-input"}-error-message`}
            className="absolute right-0 mt-1 text-xs text-red-700 -bottom-4"
          >
            {error}
          </span>
        )}
      </label>
    );
  }
);
